export default import.meta.ROLLDOWN_FILE_URL_VsfO5HHWVEbGV_iPcQpuog